// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__NW7-Y","title":"BackImages_title__gS9KO","images":"BackImages_images___g38F"};